<div class="toggle-button" [ngClass]="isInteractable ? 'interactable' : 'not-interactable'" [class.gap-16]="hasLabel()">
  <mat-slide-toggle [checked]="checked" [disabled]="disabled" (change)="toggleButtonClicked($event)">{{ label | bmsTranslate }}</mat-slide-toggle>
</div>
